import { QueryResultsRelationship, ForeignKeyRelationship, SharedKeyRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';
import { ActivityFeedResponse, ActivityFeedNewReservation } from 'data/models/ActivityFeedResponse';
import { OperationsForecastResponse, OperationsForecastPort, OperationsForecastPortDay } from 'data/models/OperationsForecast';
import { ServicesDashboardResponse } from 'data/models/ServicesDashboardResponse';


export class BerthManagerDashboardCache {
    ActivityFeedResponses = PCCollection(ActivityFeedResponse);
    ActivityFeedNewReservations = PCCollection(ActivityFeedNewReservation);

    OperationsForecastResponses = PCCollection(OperationsForecastResponse);
    PortOperations = PCCollection(OperationsForecastPort);
    PortDayOperations = PCCollection(OperationsForecastPortDay);

    ServicesDashboardResponses = PCCollection(ServicesDashboardResponse);

    constructor(data : PCCache) {
        new QueryResultsRelationship(this.ActivityFeedResponses, this.ActivityFeedNewReservations, r => r.NewReservations);
        new QueryResultsRelationship(this.ActivityFeedResponses, data.RecurringBatches,       r => r.NewBatches);
        new QueryResultsRelationship(this.ActivityFeedResponses, data.PortCallChanges,        r => r.ChangedReservations);
        new QueryResultsRelationship(this.ActivityFeedResponses, data.RecurringBatchChanges,  r => r.ChangedBatches);
        new QueryResultsRelationship(this.ActivityFeedResponses, data.TopicCardChanges,       r => r.ChangedTopicCards);
        new QueryResultsRelationship(this.ActivityFeedResponses, data.BerthReservations,      r => r.ConflictedReservations);
        new QueryResultsRelationship(this.ActivityFeedResponses, data.RecurringBatches,       r => r.ConflictedBatches);
        new QueryResultsRelationship(this.ActivityFeedResponses, data.BerthReservations,      r => r.OpenReservations);
        new SharedKeyRelationship(this.ActivityFeedNewReservations, data.BerthReservations, e => e.Reservation, null);
        new ForeignKeyRelationship(data.PCUsers, this.ActivityFeedNewReservations, null, e => e.Requestor, e => e.RequestorId());

        new QueryResultsRelationship(this.OperationsForecastResponses, this.PortOperations, f => f.Ports);
        new QueryResultsRelationship(this.PortOperations, this.PortDayOperations, p => p.Days);
        new ForeignKeyRelationship(data.Ports, this.PortOperations, null, m => m.Port, m => m.PortId());

        new QueryResultsRelationship(this.ServicesDashboardResponses, data.TopicCards, r => r.Services);
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/berthmgrdashboard/cache.ts